import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import TonalPanel from "./TonalPanel";

export default function EditorialSpread() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const yL = useTransform(scrollYProgress, [0, 1], [80, -80]);
  const yR = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section ref={ref} className="py-24 md:py-40 border-t border-ink/15">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-6">
          <motion.div style={{ y: yL }}>
            <TonalPanel
              bg="stone"
              tubeColor="#3a2530"
              cap="same"
              sublabel="LIP GLOSS"
              fig="Fig. 01"
              caption="Plum, at rest on stone."
              chapter="N° 004"
              ratio="aspect-[3/4]"
            />
          </motion.div>
        </div>

        <div className="col-span-12 md:col-span-6 md:pt-32">
          <p className="text-[10px] uppercase tracking-eyebrow text-ink/60 mb-8">Editorial</p>
          <h3 className="font-serif-display text-5xl md:text-7xl leading-[0.95] max-w-[14ch]">
            Soft light. <span className="italic font-serif-italic">Held</span> not thrown.
          </h3>
          <p className="mt-8 text-[16px] leading-[1.6] text-ink/80 max-w-[46ch]">
            We photograph against surfaces that behave like the light itself — quiet, absorbent, without spectacle.
            Travertine. Linen. Unpolished glass. Water at rest.
          </p>
          <motion.div style={{ y: yR }} className="mt-14">
            <TonalPanel
              bg="charcoal"
              tubeColor="#c9a37a"
              cap="dark"
              sublabel="LIP GLOSS"
              fig="Fig. 02"
              caption="Nude, held in shade."
              chapter="N° 005"
              ratio="aspect-[4/5]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
